import React from 'react'
import { API_URL } from '../Constants'
import { SectionBase, DifficultyBadge, Time, NextQuestion} from '../Shared/SectionBase'
import { Link } from 'react-router-dom'
import Menu from '../Shared/Menu'
import SharkImage from '../Images/shark1.webp'
import Definitions from './Definitions'
export default class ReadAndSelect extends SectionBase {

  TEST_TIME_SECONDS = 60

  state = {difficulty:1}


  constructor(props) {
    super(props)
    this.toggleSelect = this.toggleSelect.bind(this);
    this.retry = this.retry.bind(this)
    this.submit = this.submit.bind(this)
    this.nextQuestion = this.nextQuestion.bind(this)
    this.onDifficultyChange = this.onDifficultyChange.bind(this)
  }


  isCorrect(w){
    return !w.isMisspelling && w.isSelected;
  }

  getTotalCorrect() {
    const { words } = this.state;

    return words.filter(w => this.isCorrect(w)).length;
  }

  async nextQuestion(){
    console.log('nextQ');
    const secondsLeft = this.TEST_TIME_SECONDS;
    const step = 1;
    const {difficulty} = this.state;
    const { token } = this.props;

      const res = await fetch(`${API_URL}/readandselect/createquestion/${difficulty}/18`,
        { headers: { Authorization: `Token ${token}` } });
      try {
        const words = await res.json();

        for (var i = 0; i < words.length; i++) {
          const { misspellings } = words[i]
          const isMisspelling = Math.random() > .5 && misspellings.length > 0;
          words[i].isMisspelling = isMisspelling;
          if (isMisspelling) {
            words[i].incorrectWord = misspellings[Math.floor(Math.random() * misspellings.length)]
          }
        }

        console.log(words);
        this.setState({ words, secondsLeft, step },this.restartTimer);
        
      } catch (e) {
        console.log(res);
      }
  }

  onDifficultyChange(e){
    this.setState({difficulty:e.target.value}, this.nextQuestion);
    
  }

  onTimeIsUp(){
    this.setState({step:2})
  }




  render() {
    const { token } = this.props;

    const { words, secondsLeft, step, profile, difficulty } = this.state;
    return (
      <>
        {token !== null && words && <div className={`readandselect readandselect-step${step}`}>
          <Menu token={token}  profile={profile}onDifficultyChange={this.onDifficultyChange}></Menu>
          <Time seconds={secondsLeft}></Time>
          <DifficultyBadge difficulty={difficulty}></DifficultyBadge>
          <div className='px-5'>
            <h1 className='text-center'>Select the real English words</h1>
            <div className='words my-5'>{words.map((w, i) => {
              return <button key={`btn-${i}-${w}`} type="button"
                className={`word btn btn-light my-4 mx-1 ${w.isSelected ? 'active' : ''} ${step >= 2 ? (`btn-outline-${w.isMisspelling ? 'danger' : 'success'}`) : ''}`} onClick={() => { this.toggleSelect(i) }}>{w.isMisspelling ? w.incorrectWord:w.word}</button>
            })}</div>

            {step >= 2 && <>
              <div className='result mb-2 text-center'>
                You got {this.getTotalCorrect()} right out of a possible {words.filter(w=>!w.isMisspelling).length}.
              </div>
              <div className='text-center' style={{marginBottom:'-140px'}}>

                <img width="240" height="320" alt="shark character" style={{filter:'grayscale(1)'}} src={SharkImage} />
                <svg xmlns="http://www.w3.org/2000/svg" style={{display: 'none'}}>
                  <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                  </symbol>
                  <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
                  </symbol>
                  <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                  </symbol>
                </svg>

                <div className="alert bg-warning position-relative text-center" style={{top:'-140px'}} role="alert">
                  <div className='d-flex align-items-center '>
                  <svg className="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Info:">
                    <use href="#info-fill"/></svg>
                  <div className='h2'>
                    <p className='font-weight-bold'>
                    Want to learn about some of the words you missed?
                    
                    </p>
                    
                  </div>
                  </div>
                  
                  <div>
                      <button className='btn btn-primary' onClick={()=>{this.setState({ step: 3 });}}>Show Words</button>
                    </div>
                </div>
              </div>
            </>
            }

            {step >=3 && <Definitions words={words.filter(w=>!this.isCorrect(w))}></Definitions>}


            <div className='buttons d-flex justify-content-between'>
              <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.retry}>RETRY</button>

              {step === 1 && <button type="button" className={`btn btn-dark rounded-pill`} onClick={this.submit}>SUBMIT</button>
              }
            </div>
            <NextQuestion nextQuestion={this.nextQuestion}></NextQuestion>
            {false && <div>{JSON.stringify(this.state)}</div>}
          </div>
          
        </div>}
      
        {token === null && <div className='p-5'>Please <Link to="/home/">login</Link> and refresh this page</div>}

      </>

    )
  }



  retry() {
    const { words } = this.state;
    if (words !== undefined) {
      for (var i = 0; i < words.length; i++) {
        words[i].isSelected = false;
      }
    }
    this.setState({ words, step: 1, secondsLeft: this.TEST_TIME_SECONDS });
    this.restartTimer();
  }
  
  async submit(){
    const {words} = this.state;
    const submittedWords = words.filter(w=>w.isSelected).map((w)=>({
      word:w.word,
      is_mistake:  w.isMisspelling
    }))
    console.log(submittedWords);
    this.stopTimer();
    this.setState({ step: 2 });
    const res = await fetch(`${API_URL}/readandselect/submittedwords`, {
      method: 'POST',
      body: JSON.stringify(submittedWords),
      headers: { Authorization: `Token ${this.props.token}`,"Content-Type": "application/json" } 
    });
    const data = await res.json();

    console.log(data);
    
  }

  toggleSelect(i) {

    const { secondsLeft, words, step } = this.state;
    if (secondsLeft > 0 && step === 1) {
      words[i].isSelected = !words[i].isSelected;
      this.setState({ words });
    }

  }
}
